import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionBookDashboardDTO  {
    _originalTypeClassName = "zERP.BO.TransactionBookDashboardDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionBookDashboardDTO.translate = translateService;
}
this.TransactionsPerCategoryData = [];
this.VatCategories = [];
this.NoOfSalesInvoices = null;
this.NoOfPurchaseInvoices = null;
this.NoOfTransactionEntries = null;
this.TransactionBookDashboardDTOKey = null;
this._key = this.TransactionBookDashboardDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
NoOfSalesInvoices:any;
NoOfPurchaseInvoices:any;
NoOfTransactionEntries:any;
TransactionsPerCategoryData:any;
VatCategories:any;
private _TransactionBookDashboardDTOKey:any;
get TransactionBookDashboardDTOKey(): any {
    return this._TransactionBookDashboardDTOKey;
  }
set TransactionBookDashboardDTOKey(value: any) {
    this._TransactionBookDashboardDTOKey = value;
    this._key = value;
  }
static setTransactionsPerCategoryData = ($this, items) => {
                if (items == null) items = [];
                if ($this.TransactionsPerCategoryData == null) $this.TransactionsPerCategoryData = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TransactionsPerCategoryData.length > 0) {
                    Domain.TransactionBookDashboardDTO.removeTransactionsPerCategoryData($this, $this.TransactionsPerCategoryData[0]);
                }

                Domain.TransactionBookDashboardDTO.addManyTransactionsPerCategoryData($this, copyItems);
            }
static addManyTransactionsPerCategoryData = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TransactionBookDashboardDTO.addTransactionsPerCategoryData($this, items[i]);
                }
            }
static addTransactionsPerCategoryData = ($this, item) => {
                if ($this.TransactionsPerCategoryData == null) $this.TransactionsPerCategoryData = [];
                if (item == null || $this.TransactionsPerCategoryData.indexOf(item) > -1) return;
                $this.TransactionsPerCategoryData.push(item);
}
static addRangeTransactionsPerCategoryData = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TransactionBookDashboardDTO.addTransactionsPerCategoryData($this, item));
            }
static removeTransactionsPerCategoryData = ($this, item) => {
                if ($this == null || $this.TransactionsPerCategoryData == null || $this.TransactionsPerCategoryData.indexOf(item) === -1) return;
                var _index = $this.TransactionsPerCategoryData.indexOf(item);
                $this.TransactionsPerCategoryData.splice(_index, 1);
}
static clearTransactionsPerCategoryData = ($this) => { $this.TransactionsPerCategoryData = null; }
static setVatCategories = ($this, items) => {
                if (items == null) items = [];
                if ($this.VatCategories == null) $this.VatCategories = [];

                const copyItems = Common.cloneObject(items);

                while ($this.VatCategories.length > 0) {
                    Domain.TransactionBookDashboardDTO.removeVatCategories($this, $this.VatCategories[0]);
                }

                Domain.TransactionBookDashboardDTO.addManyVatCategories($this, copyItems);
            }
static addManyVatCategories = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TransactionBookDashboardDTO.addVatCategories($this, items[i]);
                }
            }
static addVatCategories = ($this, item) => {
                if ($this.VatCategories == null) $this.VatCategories = [];
                if (item == null || $this.VatCategories.indexOf(item) > -1) return;
                $this.VatCategories.push(item);
}
static addRangeVatCategories = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TransactionBookDashboardDTO.addVatCategories($this, item));
            }
static removeVatCategories = ($this, item) => {
                if ($this == null || $this.VatCategories == null || $this.VatCategories.indexOf(item) === -1) return;
                var _index = $this.VatCategories.indexOf(item);
                $this.VatCategories.splice(_index, 1);
}
static clearVatCategories = ($this) => { $this.VatCategories = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TransactionBookDashboardDTOKey == null || $this.TransactionBookDashboardDTOKey == 0;
            }


}